import { LOGIN as SOCKET_LOGIN, REGISTER as SOCKET_REGISTER } from '../../events/ClientToServer'
import { 
    SAVE_EXP_USER as SOCKET_SAVE_EXP_USER,
    LOG_OUT as SOCKET_LOG_OUT,
    DELETE_USER as SOCKET_DELETE_USER,
    START_PLAYING as SOCKET_START_PLAYING,
    STOP_PLAYING as SOCKET_STOP_PLAYING,
    TEMPORARY_LOGIN as SOCKET_TEMPORARY_LOGIN,
    PASSWORD_RESET as SOCKET_PASSWORD_RESET, 
    UPDATE_PASSWORD as SOCKET_UPDATE_PASSWORD
} from '../../events/ClientToServer'
import { MODERATE_USER as SOCKET_MODERATE_USER } from '../../events/ClientToServer'

export const LOGIN = 'LOGIN'
export const TEMPORARY_LOGIN = 'TEMPORARY_LOGIN'
export const LOGIN_RESULT = 'LOGIN_RESULT'
export const POSITION_UPDATED = 'POSITION_UPDATED'
export const REGISTER = 'REGISTER'
export const PASSWORD_RESET = 'PASSWORD_RESET'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const PASSWORD_UPDATED = 'PASSWORD_UPDATED'
export const SAVE_EXP_USER = 'SAVE_EXP_USER'
export const MODERATE_USER = 'MODERATE_USER'
export const BEEN_MODERATED = 'BEEN_MODERATED'
export const LOG_OUT = 'LOG_OUT'
export const START_PLAYING = 'START_PLAYING'
export const STOP_PLAYING = 'STOP_PLAYING'  
export const DELETE_USER = 'DELETE_USER'
export const USER_DELETED = 'USER_DELETED'
export const LOGGED_OUT = 'LOGGED_OUT'
export const  MobileDetect = require('mobile-detect');
export const md = new MobileDetect(window.navigator.userAgent);
export const LAPTOP = 'LAPTOP'
export const MOBILE = 'MOBILE'
export const UPDATE_OWN_AVATAR = 'UPDATE_OWN_AVATAR'

export const login = (socket, username, password, name) => {
    const is_mobile = md.mobile();
    socket.emit(SOCKET_LOGIN, { username, password, name, is_mobile:is_mobile })
    return { type: LOGIN, username, password, name, is_mobile }
}

export const register = (socket, email, username, password) => {
    socket.emit(SOCKET_REGISTER, { email, username, password })
    return { type: REGISTER, email, username, password }
}

export const resetPasssword = (socket, email) => {
    socket.emit(SOCKET_PASSWORD_RESET, { email})
    return { type: PASSWORD_RESET, email}
}

export const updatePassword = (socket, resetPasswordToken, password) => {
    socket.emit(SOCKET_UPDATE_PASSWORD, { resetPasswordToken, password})
    return { type: UPDATE_PASSWORD, resetPasswordToken, password}
}

export const passwordUpdated = (user_id) => {
    return { type: PASSWORD_UPDATED, user_id }
}

export const temporaryLogin = (socket, username, password, nameGame) => {
    const is_mobile = md.mobile();
    socket.emit(SOCKET_TEMPORARY_LOGIN, {username, password, nameGame, is_mobile:is_mobile })
    return { type: TEMPORARY_LOGIN,  username, password, nameGame, is_mobile }
}

export const loginResult = (user) => {
    return { type: LOGIN_RESULT, ...user }
}


export const moderateUser = (socket, {user_id}) => {
    socket.emit(SOCKET_MODERATE_USER, { user_id })
    return { type: MODERATE_USER, user_id }
}


export const beenModerated = ({user_id}) => {
    return { type: BEEN_MODERATED, user_id }
}

export const positionUpdated = (user_id, position, numPlayers, balance) => {
    return { type: POSITION_UPDATED, user_id, position, numPlayers, balance }
}

export const logOut = (socket,{user}) => {
    socket.emit(SOCKET_LOG_OUT, { user })
    return { type: LOG_OUT, user }
}

export const startPlaying = (socket,{user_id}) => {
    socket.emit(SOCKET_START_PLAYING, { user_id })
    return { type: START_PLAYING, user_id }
}

export const stopPlaying = (socket,{user_id}) => {
    socket.emit(SOCKET_STOP_PLAYING, { user_id })
    return { type: STOP_PLAYING, user_id }
}


export const deleteUser = (socket,{user}) => {
    socket.emit(SOCKET_DELETE_USER,  user)
    return { type: DELETE_USER, user }
}

export const userDeleted = (user_id) => {
    window.location.reload();
    return {type: USER_DELETED, user_id}
}

export const loggedOut = (user) => {
    window.location.reload();
    return {type: LOGGED_OUT, user}
}

export const expanseUser = (socket,id,from,claim,real_name,paypal_account,has_webcam, avatar, username) => {
    socket.emit(SOCKET_SAVE_EXP_USER, {id,from,claim,real_name,paypal_account,has_webcam, avatar, username})
    return { type: SAVE_EXP_USER, id, from,claim,real_name,paypal_account,has_webcam, avatar, username}
}

export const updateOwnAvatar = (avatar) => {
    return { type: UPDATE_OWN_AVATAR, avatar }
}



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js